import { render, staticRenderFns } from "./PriceSetFilter.vue?vue&type=template&id=4358e5ca&scoped=true&"
import script from "./PriceSetFilter.vue?vue&type=script&lang=js&"
export * from "./PriceSetFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriceSetFilter.vue?vue&type=style&index=0&id=4358e5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358e5ca",
  null
  
)

export default component.exports